import React from 'react';

/**
 * CustomIcon Component
 * Custom icon dosyalarını kullanmak için component
 * 
 * Kullanım:
 * <CustomIcon name="sponsors" className="w-6 h-6" />
 * 
 * Icon dosyalarını client/public/icons/ klasörüne yükleyin:
 * - sponsors.svg veya sponsors.png
 * - games.svg veya games.png
 * - tickets.svg veya tickets.png
 */
const CustomIcon = ({ name, className = "w-6 h-6", alt = "" }) => {
  // Public klasöründeki icon'lar /icons/ yolundan erişilebilir
  // Önce PNG, sonra SVG, son olarak da JPG/JPEG dener (PNG öncelikli çünkü kullanıcı PNG yüklemiş)
  const iconExtensions = ['.png', '.svg', '.jpg', '.jpeg'];
  const [iconSrc, setIconSrc] = React.useState(`/icons/${name}.png`);
  const [currentExtIndex, setCurrentExtIndex] = React.useState(0);
  const [hasError, setHasError] = React.useState(false);

  const handleError = () => {
    // Bir sonraki uzantıyı dene
    if (currentExtIndex < iconExtensions.length - 1) {
      const nextIndex = currentExtIndex + 1;
      setCurrentExtIndex(nextIndex);
      setIconSrc(`/icons/${name}${iconExtensions[nextIndex]}`);
    } else {
      // Tüm uzantılar denendi, icon bulunamadı
      setHasError(true);
      console.warn(`Icon not found: ${name}. Please add the icon file to public/icons/ folder.`);
    }
  };

  if (hasError) {
    return null;
  }

  return (
    <img 
      src={iconSrc} 
      alt={alt || name} 
      className={className}
      onError={handleError}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default CustomIcon;
